import { render, staticRenderFns } from "./201.vue?vue&type=template&id=5b68b04c&scoped=true&"
var script = {}
import style0 from "./201.vue?vue&type=style&index=0&id=5b68b04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68b04c",
  null
  
)

export default component.exports